const apiUrl = process.env.REACT_APP_API_URL;
export const GetTasquesByprojecteId = async (id_projecte : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/tasques`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
